const SupervisorsList = ({
  context,
  loading,
  setModalRemoveObject,
  setModalIsOpen,
  setType,
}) => {
  return (
    <>
      <div className='col-12 my-3 overflow-auto'>
        <div className='d-flex flex-row align-items-center my-3'>
          <i className='far fa-users f-18 text-dark'></i>
          <span className='text-dark f-14 font-weight-bold mx-2'>
            لیست سرپرست ها
          </span>
        </div>

        <>
          {context?.supervisors?.length > 0 ? (
            <table
              className='table table-striped my-3 text-left'
              style={{ minWidth: "992px" }}
            >
              <thead>
                <tr className='bg-purple text-white'>
                  <th scope='col'>#</th>
                  <th scope='col'>نام و نام خانوادگی</th>
                  <th scope='col'>کد ملی</th>
                  <th scope='col'>حذف</th>
                </tr>
              </thead>
              <tbody>
                {context?.supervisors?.map((user, index) => (
                  <tr key={user?.id}>
                    <th scope='row'>{index + 1}</th>
                    <td>
                      {user?.name} {user?.last_name}
                    </td>
                    <td>{user?.national_card_id}</td>
                    <td>
                      <i
                        className='fal fa-trash text-danger f-18 c-pointer mt-2'
                        onClick={() => {
                          setType(2);
                          setModalRemoveObject(user);
                          setModalIsOpen(true);
                        }}
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className='d-flex flex-row justify-content-center align-items-center my-3'>
              اطلاعاتی جهت نمایش یافت نشد.
            </div>
          )}
        </>
      </div>
    </>
  );
};

export default SupervisorsList;
